export const PreQualifierLoadingProductErrorViewMessages = {
  errorMessage: {
    id: 'Pages.LoadingProduct.Page.errorMessage',
    description: 'Error Message when failed to fetch product',
  },
}
